import { isIsoRiskList } from "@design-controls/types";
import { useCurrentUser } from "@qualio/ui-components";
import { useQuery } from "react-query";
import { useCurrentProduct } from "../useCurrentProduct";
import { designControlsApi } from "../../api/designControls";

export const useISORiskList = () => {
  const { companyId } = useCurrentUser();
  const { id: productId } = useCurrentProduct();

  const { isLoading, data } = useQuery({
    queryFn: () => designControlsApi.query(companyId, productId),
    queryKey: ["OPEN_ISSUE_LIST", companyId, productId],
    select: (records) => records.filter(isIsoRiskList),
  });

  return {
    isLoading,
    data,
  };
};
